<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { TextInputDefinition } from 'header/types';

    interface Props {
        field: TextInputDefinition;
    }

    let { field }: Props = $props();

    const dispatch = createEventDispatcher();

    const onChange = (e: { currentTarget: HTMLInputElement }) => {
        dispatch('change', {
            field: {
                ...field,
                value: e.currentTarget.value,
            },
        });
    };
</script>

<input
    class="input"
    type="text"
    disabled={field.changeable === false}
    value={field.value}
    oninput={onChange}
/>

<style lang="scss" scoped>
    .input {
        width: 100%;
    }
</style>
